import {
    Card,
    CardActionArea,
    CardActions,
    Fab,
    Grid,
    makeStyles,
    Slide,
    Typography,
} from "@material-ui/core"
import { Add } from "@material-ui/icons"
import React, { useContext, useEffect, useState } from "react"

import Cabecalho from "../Cabecalho"

import { useSnackbar } from "notistack"
import { useHistory } from "react-router-dom"
import ServicosContext from "../../contexts/servicosContext"
import { RegistrarLogErro } from "../../services/clientefiel"
import { BuscarMesas } from "../../services/integracao"
import { valorTotalDaMesa } from "../RegistradorDePedidos/functions"
import DetalhesPedido from "./DetalhesPedido"
import ListaPedidosMesa from "./ListaPedidosMesa"

const qz = require("qz-tray")

const useStyles = makeStyles(theme => ({
    containerCabecalho: {
        height: "4rem",
        [theme.breakpoints.down("xs")]: {
            height: "3.5rem",
        },
    },
    containerCartoesMesa: {
        padding: "1rem",
        margin: 0,
        width: "100vw",
    },
    cartaoMesa: { height: "9rem", display: "flex", flexDirection: "column" },
    cartaoMesaDados: {
        flex: 5,
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-around",
        alignItems: "center",
        padding: "1rem",
        gap: "1rem",
    },
    numeroMesa: {
        flex: 2,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },
    dadosMesa: {
        flex: 2,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
    },
    nomeMesa: {
        width: "40%",
        display: "flex",
        flexDirection: "column",
        "& > span": {
            display: "inline-flex",
            whiteSpace: "nowrap",
            overflow: "hidden",
            margin: "0 auto",
            width: "100%",
            justifyContent: "center",
        },
    },
    statusMesa: {
        padding: "3px",
        textAlign: "center",
    },
    dadosPedidoMesa_container: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-around",
        alignItems: "center",
        flex: 4,
    },
    cartaoMesaDesconto: {
        padding: 0,
        flex: 2,
    },
    cartaoMesaDesconto_texto: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "white",
        width: "100%",
        height: "100%",
    },
    valorDesconto: {
        background: "#28a745",
    },
    semDesconto: {
        background: "#6c757d",
    },
    noPadding: { padding: 0 },
    botaoEstaticoAdd: {
        background: "#28a745",
        color: "white",
        position: "fixed",
        bottom: "1.75rem",
        right: "1.75rem",
        "& > span": {
            display: "flex",
            gap: "0.25rem",
        },
        "&:hover": {
            backgroundColor: "#2fc550",
        },
    },
    botaoEstaticoClose: {
        background: "#dc3545",
        color: "white",
        position: "fixed",
        bottom: "5.25rem",
        right: "1.75rem",
        "& > span": {
            display: "flex",
            gap: "0.25rem",
        },
        "&:hover": {
            backgroundColor: "#EB4B5B",
        },
    },
    appBar: {
        "& > div": {
            justifyContent: "space-between",
            margin: "0 3rem",
        },
    },
    opcaoImpressoraLabel: {
        background: "white",
        borderRadius: "10px",
        padding: "2px 10px",
    },
    selecaoImpressora: {
        width: "200px",
        background: "white",
        opacity: 0.85,
    },
    botoesImpressoras: {
        display: "flex",
        gap: "0.75rem",
        "& > button": {
            backgroundColor: "#6c757d",
            color: "white",
        },
    },
    listaPedidosImpressao: {
        maxWidth: "22rem",
        margin: "auto",
        "& > button": { background: "#d8d8d8", margin: "0.25rem 0" },
        "& > button > span": { display: "flex", gap: "0.75rem" },
    },
    botaoImprimir: {
        color: "#28a745",
    },
    botaoFecharMesa: { color: "white", background: "#dc3545" },
}))

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />
})

const CardMesa = props => {
    const { configuracoes } = useContext(ServicosContext)
    const classes = useStyles()

    const [totalMesa] = useState(valorTotalDaMesa(props.mesa.pedidosMesa))

    const [nomesMesa] = useState(
        props.mesa.pedidosMesa.reduce((listaNomes, pedido) => {
            if (
                listaNomes.length < 3 &&
                !listaNomes.includes(pedido.cliente.nome) &&
                pedido.cliente.nome !== "Anônimo"
            )
                listaNomes.push(pedido.cliente.nome)

            return listaNomes
        }, [])
    )

    const handleClick = () => props.setMesaSelecionada(props.mesa)

    return (
        <Grid item xs={4}>
            <Card className={classes.cartaoMesa}>
                <CardActionArea onClick={handleClick} className={classes.cartaoMesaDados}>
                    <Typography variant="h2" component="span" className={classes.numeroMesa}>
                        {props.mesa.numeroMesa}
                    </Typography>

                    <span className={classes.dadosMesa}>
                        <Typography variant="body2" color="textSecondary" component="p">
                            {props.mesa.pedidosMesa?.length} pedidos
                        </Typography>
                        <Typography variant="body2" component="span">
                            {Intl.NumberFormat("pt-BR", {
                                style: "currency",
                                currency: "BRL",
                            }).format(totalMesa)}
                        </Typography>
                    </span>
                    <div className={classes.nomeMesa}>
                        {nomesMesa.length ? (
                            nomesMesa.slice(0, 3).map(nome => (
                                <Typography key={nome} gutterBottom component="span">
                                    {nome.slice(0, 16)}
                                </Typography>
                            ))
                        ) : (
                            <Typography gutterBottom component="span">
                                Anônimo
                            </Typography>
                        )}
                    </div>
                </CardActionArea>
                <CardActions className={classes.noPadding}>
                    <Typography
                        variant={"button"}
                        className={[
                            classes.statusMesa,
                            configuracoes.user.parametros == null
                                ? "botaoCinza naoArredondado"
                                : configuracoes.user.parametros.exibirRegistroPedidos
                                ? "botaoVerde naoArredondado"
                                : "botaoVermelho naoArredondado",
                        ].join(" ")}
                    >
                        ABERTA
                    </Typography>
                </CardActions>
            </Card>
        </Grid>
    )
}

const GerenciadorMesas = () => {
    const autorizacao = localStorage.getItem("chaveSistema")

    const [listaMesas, setListaMesas] = useState([])
    const [mesaSelecionada, setMesaSelecionada] = useState()
    const [pedidoSelecionado, setPedidoSelecionado] = useState({})
    const [closeDetalhes, setCloseDetalhes] = useState(false)

    const [impressorasQZ, setImpressorasQZ] = useState([])

    const classes = useStyles()
    const history = useHistory()

    const lista = listaMesas.filter(e => !e.naoTem)

    const { enqueueSnackbar } = useSnackbar()
    const alertStart = (msg, tipo) => {
        enqueueSnackbar(msg, { variant: tipo })
    }

    const handleOpen = async () => {
        try {
            const retorno = await BuscarMesas(autorizacao)
            if (retorno.retornoErro) {
                alertStart(retorno.mensagem, "error")
                return false
            }

            if (retorno.length === 0) {
                setListaMesas([{ naoTem: true }])
            } else {
                setListaMesas(retorno)
            }
        } catch (error) {
            RegistrarLogErro(error, "handleOpenGerenciamentoMesa")
            alertStart("Procure os desenvolvedores! Erro: " + error.message, "error")
        }
    }

    useEffect(() => {
        handleOpen()
    }, [])

    return (
        <div>
            <div className={classes.containerCabecalho}>
                <Cabecalho pagina="Gerenciador de Mesas" gerarQRCode />
            </div>
            <Grid container spacing={4} className={classes.containerCartoesMesa}>
                {listaMesas
                    .sort((a, b) => a.numeroMesa - b.numeroMesa)
                    .map((mesa, index) =>
                        mesa?.pedidosMesa?.length ? (
                            <CardMesa
                                key={index}
                                mesa={mesa}
                                setMesaSelecionada={setMesaSelecionada}
                            />
                        ) : null
                    )}
            </Grid>
            <Fab
                variant="extended"
                aria-label="add"
                className={classes.botaoEstaticoAdd}
                onClick={() => history.push("/servicos/modulo/registrador-de-pedidos?mesa=0")}
            >
                <Add className={classes.addIcon} />
                Adicionar Pedido
            </Fab>
            <ListaPedidosMesa
                mesa={mesaSelecionada}
                setPedidoSelecionado={setPedidoSelecionado}
                handleClose={() => setMesaSelecionada(undefined)}
                useStyles={useStyles}
                Transition={Transition}
                impressorasQZ={impressorasQZ}
                setImpressorasQZ={setImpressorasQZ}
                alertStart={alertStart}
            />
            <DetalhesPedido
                pedidoSelecionado={pedidoSelecionado}
                handleClose={() => {
                    setCloseDetalhes(true)
                    setTimeout(() => {
                        setPedidoSelecionado({})
                        setCloseDetalhes(false)
                    }, 200)
                }}
                Transition={Transition}
                close={closeDetalhes}
                useStyles={useStyles}
            />
        </div>
    )
}

export default GerenciadorMesas
